/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./views.vue?vue&type=template&id=00efc1a5&scoped=true"
import script from "./views.vue?vue&type=script&lang=js"
export * from "./views.vue?vue&type=script&lang=js"
import style0 from "./views.vue?vue&type=style&index=0&id=00efc1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efc1a5",
  null
  
)

export default component.exports